import FunctionsRepository from "@/repositories/FunctionRepository";
import makeState from "@/storages/Base/State";
import makeGetters from "@/storages/Base/Getters";
import makeMutations from "@/storages/Base/Mutations";

export default {
    name: 'functions',
    namespaced: true,
    state: makeState(),
    getters: makeGetters(),
    mutations: makeMutations(),
    actions: {
        async listOne({commit, state}, id) {
            commit('setLoading', true)
            await FunctionsRepository.fetch(id).then(response => {
                commit('setCurrent', response.data.data)
            })
            commit('setLoading', false)
        },
        async listAllPaginated({commit}, params) {
            commit('setLoading', true)
            await FunctionsRepository.fetchAll(params).then(response => {
                commit('setAll', response.data.data.data)
                commit('setPagination', response.data.data)
            })
            commit('setLoading', false)
        },
        async search ({ commit, state }, params) {
            commit('setLoading', true)
            await FunctionsRepository.search(params).then(response => {
                if (response.data.data.cloudFunctions.length > 0){
                    const array = response.data.data.cloudFunctions
                    commit('setAll', Object.values([...state.list, ...array].reduce((acc,cur)=>Object.assign(acc,{[cur.id]:cur}),{})))
                }
            })
            commit('setLoading', false)
        }
    }
}
